import React, { useState } from "react";
import { useDispatch } from "react-redux";
import LocationIcon from "./img/icons/Frame.svg";
import PersonIcon from "./img/icons/Vector (1).svg";
import BoxIcon from "./img/icons/Vector (3).svg";
import { useSelector } from "react-redux";
import { addTicket } from "../redux/filghtBookApp/actions";

const FromInput = () => {
  const selector = useSelector((state) => state.flightApp);
  // console.log(selector);
  const dispatch = useDispatch();

  const [destinationFrom, setDestinationFrom] = useState("");
  const [destinationTo, setDestinationTo] = useState("");
  const [date, setDate] = useState("");
  const [totalguest, setTotalGuest] = useState("");
  const [ticketClass, setTicketClass] = useState("");

  //   console.log(destinationFrom);
  const resetFrom = () => {
    setDestinationFrom("");
    setDestinationTo("");
    setDate("");
    setTotalGuest("");
    setTicketClass("");
  };

  const submitFromHandler = (e) => {
    e.preventDefault();
    let newId = selector.length + 1;
    let data = {
      id: newId,
      from: destinationFrom,
      to: destinationTo,
      date,
      totalguest,
      ticketClass,
    };

    dispatch(addTicket(data));
    resetFrom();
  };

  return (
    <div>
      <form className="first-hero lws-inputform" onSubmit={submitFromHandler}>
        {/* From */}
        <div className="des-from">
          <p>Destination From</p>
          <div className="flex flex-row">
            <img src={LocationIcon} alt="" />
            <select
              className="outline-none px-2 py-2 w-full"
              name="from"
              id="lws-from"
              required
              value={destinationFrom}
              onChange={(e) => setDestinationFrom(e.target.value)}
            >
              <option value="" hidden>
                Please Select
              </option>
              <option value={"Dhaka"}>Dhaka</option>
              <option value={"Sylhet"}>Sylhet</option>
              <option value={"Saidpur"}>Saidpur</option>
              <option value={"Cox's Bazar"}>Cox's Bazar</option>
            </select>
          </div>
        </div>

        {/* To */}
        <div className="des-from">
          <p>Destination To</p>
          <div className="flex flex-row">
            <img src={LocationIcon} alt="" />
            <select
              className="outline-none px-2 py-2 w-full"
              name="to"
              id="lws-to"
              required
              value={destinationTo}
              onChange={(e) => setDestinationTo(e.target.value)}
            >
              <option value="" hidden>
                Please Select
              </option>
              <option value={"Dhaka"}>Dhaka</option>
              <option value={"Sylhet"}>Sylhet</option>
              <option value={"Saidpur"}>Saidpur</option>
              <option value={"Cox's Bazar"}>Cox's Bazar</option>
            </select>
          </div>
        </div>

        {/* Date */}
        <div className="des-from">
          <p>Journey Date</p>
          <input
            type="date"
            className="outline-none px-2 py-2 w-full date"
            name="date"
            id="lws-date"
            required
            value={date}
            onChange={(e) => setDate(e.target.value)}
          />
        </div>

        {/* Guests */}
        <div className="des-from">
          <p>Guests</p>
          <div className="flex flex-row">
            <img src={PersonIcon} alt="" />
            <select
              className="outline-none px-2 py-2 w-full"
              name="guests"
              id="lws-guests"
              required
              value={totalguest}
              onChange={(e) => setTotalGuest(e.target.value)}
            >
              <option value="" hidden>
                Please Select
              </option>
              <option value={"1"}>1 Person</option>
              <option value={"2"}>2 Persons</option>
              <option value={"3"}>3 Persons</option>
              <option value={"4"}>4 Persons</option>
            </select>
          </div>
        </div>

        {/* Class */}
        <div className="des-from !border-r-0">
          <p>Class</p>
          <div className="flex flex-row">
            <img src={BoxIcon} alt="" />
            <select
              className="outline-none px-2 py-2 w-full"
              name="ticketClass"
              id="lws-ticketClass"
              required
              value={ticketClass}
              onChange={(e) => setTicketClass(e.target.value)}
            >
              <option value="" hidden>
                Please Select
              </option>
              <option value={"Business"}>Business</option>
              <option value={"Economy"}>Economy</option>
            </select>
          </div>
        </div>

        {/* Submit Button */}
        <button
          className={`addCity ${selector.length >= 3 && "cursor-not-allowed"}`}
          type="submit"
          id="lws-addCity"
          disabled={selector.length >= 3}
        >
          <svg
            width="15px"
            height="15px"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="2"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M12 4.5v15m7.5-7.5h-15"
            />
          </svg>
          <span className="text-sm">Book</span>
        </button>
      </form>
    </div>
  );
};

export default FromInput;
